import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { injectIntl, defineMessages } from 'react-intl'
import { compose } from 'recompose'
import { OnboardingTestForm } from '../forms'
import { createTest } from '../../common/tests/actions'
import { setUserInfo } from '../../common/users/actions'
import { roles } from '../../common/config'


class FirstTestPage extends React.Component {
  componentDidMount() {
    const { setUserInfo } = this.props
    setUserInfo({ role: roles.TEACHER })
  }

  render() {
    const { intl, createTest, history } = this.props

    return (
      <div className="overlay-container">
        <OnboardingTestForm
          closeLink="/app/tests"
          isTestCreateForm
          submitTest={createTest}
          label={intl.formatMessage(messages.createTest)}
          description={intl.formatMessage(messages.testAddress)}
        />
      </div>
    )
  }
}


FirstTestPage.propTypes = {
  createTest: PropTypes.func.isRequired,
  setUserInfo: PropTypes.func.isRequired,
  history: PropTypes.object.isRequired,
}

const enhance = compose(
  connect(() => ({ }), { createTest, setUserInfo }),
  injectIntl,
)

export default enhance(FirstTestPage)

const messages = defineMessages({
  createTest: {
    id: 'testForm.page.createTest',
    defaultMessage: 'Vytvoriť test',
  },
  testAddress: {
    id: 'testForm.page.testAddress',
    defaultMessage: 'Každý test dostane pridelenú adresu, na ktorej bude ľahko dostupný pre žiakov.',
  },
})



// WEBPACK FOOTER //
// ./src/browser/pages/FirstTestPage.js